<template>
  <footer class="footer-bar">
    <div class="d-flex align-items-center footer-bar__row">
      <div class="d-flex align-items-center footer-bar__links">
        <footer-item title="Insights" :links="insightsLinks" />

        <footer-item title="Tellimer" :links="tellimerLinks" />

        <dropdown class="dropup" trigger="click">
          <template v-slot:trigger> Get in Touch </template>
          <div class="get-in-touch">
            <div class="d-flex flex-column">
              <span> General Enquiries: </span>
              <a href="tel:+44 20 7725 1000">+44 20 7725 1000</a>
              <a href="mailto:hello@tellimer.com">hello@tellimer.com</a>
            </div>
            <div class="mt-3 d-flex flex-column">
              <span>Sales:</span>
              <a href="tel:+44 20 7725 1000">+44 20 7725 1000</a>
              <a href="mailto:sales@tellimer.com">sales@tellimer.com</a>
            </div>
          </div>
        </dropdown>

      </div>

      <div class="d-flex footer-bar__social-more">
        <dropdown class="ml-md-auto footer-bar__more-menu" trigger="click">
          <template v-slot:trigger>
            <button>
              <icon icon="more-menu" />
            </button>
          </template>
          <dropdown-option v-for="(link, index) in moreLinks" :key="index">
            <a :href="link.url">{{ link.title }}</a>
          </dropdown-option>
        </dropdown>

        <div class="footer-social">
          <a href="https://twitter.com/TellimerHQ" target="_blank" class="mr-3">
            <icon icon="twitter" />
          </a>
          <a href="https://www.linkedin.com/company/tellimer" target="_blank">
            <icon icon="linkedin" />
          </a>
        </div>
      </div>
    </div>

    <div class="d-flex footer-bar__row footer-bar__row--fca">
      <span>© 2020 Tellimer</span>
      <span
        >Tellimer Limited (FRN 920001) is an Appointed Representative of Met
        Facilities LLP (FRN 587084) which is authorised and regulated by the
        Financial Conduct Authority.</span
      >
    </div>
  </footer>
</template>

<script>
import FooterItem from './footer-bar/FooterItem'
import Dropdown from '@/components/Dropdown/Dropdown'
import DropdownOption from '@/components/Dropdown/DropdownOption'

export default {
  name: 'Footer',

  components: {
    FooterItem,
    Dropdown,
    DropdownOption,
  },

  data() {
    return {
      insightsLinks: [
        {
          title: 'Headlines',
          url: `${process.env.VUE_APP_PORTAL_URL}headlines`,
        },
        {
          title: 'Sectors',
          url: `${process.env.VUE_APP_PORTAL_URL}sectors`,
        },
        {
          title: 'Regions',
          url: `${process.env.VUE_APP_PORTAL_URL}regions`,
        },
        {
          title: 'Companies',
          url: `${process.env.VUE_APP_PORTAL_URL}companies`,
        },
        {
          title: 'Channels',
          url: `${process.env.VUE_APP_PORTAL_URL}channels`,
        },
        {
          title: 'Analysts',
          url: `${process.env.VUE_APP_PORTAL_URL}analysts`,
        },
      ],
      tellimerLinks: [
        {
          title: 'Insights',
          url: `${process.env.VUE_APP_TELLIMER_URL}solutions#insights`,
        },
        {
          title: 'Analytics',
          url: `${process.env.VUE_APP_TELLIMER_URL}solutions#analytics`,
        },
        {
          title: 'Markets',
          url: `${process.env.VUE_APP_TELLIMER_URL}solutions#markets`,
        },
        {
          title: 'Advisory',
          url: `${process.env.VUE_APP_TELLIMER_URL}solutions#advisory`,
        },
        {
          title: 'News',
          url: `${process.env.VUE_APP_TELLIMER_URL}#news`,
        },
        // {
        //   title: 'Events',
        //   url: `${process.env.VUE_APP_TELLIMER_URL}events`,
        // },
        // {
        //   title: 'Community',
        //   url: `${process.env.VUE_APP_TELLIMER_URL}community`,
        // },
        {
          title: 'Contact',
          url: `${process.env.VUE_APP_TELLIMER_URL}contact`,
        },
      ],
      moreLinks: [
        {
          title: 'AML',
          url: `${process.env.VUE_APP_TELLIMER_URL}help?q=AML`,
        },
        {
          title: 'Legal & Regulatory',
          url: `${process.env.VUE_APP_TELLIMER_URL}help?q=legal`,
        },
        {
          title: 'Ratings',
          url: `${process.env.VUE_APP_TELLIMER_URL}help?q=ratings`,
        },
        {
          title: 'Disclosures',
          url: `${process.env.VUE_APP_TELLIMER_URL}help?q=disclosures`,
        },
        {
          title: 'Disclaimers',
          url: `${process.env.VUE_APP_TELLIMER_URL}help?q=disclaimers`,
        },
        {
          title: 'Privacy',
          url: `${process.env.VUE_APP_TELLIMER_URL}help?q=privacy`,
        },
        {
          title: 'Conflicts',
          url: `${process.env.VUE_APP_TELLIMER_URL}help?q=conflicts`,
        },
        {
          title: 'Terms',
          url: `${process.env.VUE_APP_TELLIMER_URL}help?q=terms`,
        },
        {
          title: 'Best Execution',
          url: `${process.env.VUE_APP_TELLIMER_URL}help?q=best`,
        },
      ],
    }
  },
}
</script>

<style lang="scss">
.footer-bar {
  position: absolute;
  bottom: -142px;
  left: 0;
  width: 100%;
  font-size: 14px;
  background: $footer-background;
  color: $input-placeholder-color;

  .dropdown-menu {
    border-color: transparent !important;
  }

  @media (max-width: 576px) {
    position: relative;
    width: calc(100% + 30px);
    margin: 0 -15px;
  }

  &__row {
    height: 70px;
    border-top: 1px solid $border-color;

    &--fca {
      padding: 1.5rem 2rem;
      align-items: center;
      justify-content: space-between;

      @media (max-width: 568px) {
        align-items: flex-start !important;
        justify-content: flex-start !important;
      }
    }

    @media (max-width: 568px) {
      height: unset;
      flex-direction: column;
    }
  }

  &__links {
    padding: 1.5rem 2rem;
    flex: 1;

    button {
      padding: 0;
      margin-right: 2rem;
      border: 0;
      background: none;
      outline: none;

      &:hover,
      &:active,
      &:focus {
        background: none;
        outline: none;
        color: #101820;
      }
    }

    @media (max-width: 568px) {
      width: 100%;
      padding: 0;
      flex-direction: column;

      .el-dropdown {
        height: 3rem;
        width: 100%;
        display: flex;
        align-items: center;

        button {
          margin: 0 auto;
        }

        &:not(:last-child) {
          border-bottom: 1px solid $border-color;
        }
      }
    }
  }

  &__social-more {
    height: 100%;
    margin-left: auto;
    padding: 0 2rem;

    @media (max-width: 568px) {
      height: 3rem;
      width: 100%;
      margin-left: unset;
      padding: 0;
      border-top: 1px solid $border-color;
    }

    .footer-bar__more-menu {
      display: flex;
      align-items: center;
      justify-content: center;
      border-right: 1px solid $border-color;
      button {
        padding: 0;
        margin-right: 2rem;
        border: 0;
        background: none;
        outline: none;

        &:hover,
        &:active,
        &:focus {
          background: none;
          outline: none;
          color: #101820;
        }
      }

      .i {
        width: 1rem;
        height: 1rem;
        margin-left: 0.25rem;
        font-size: 14px;
      }

      @media (max-width: 568px) {
        flex: 1;

        button {
          margin: 0;
        }
      }
    }

    .footer-social {
      margin-left: 2rem;
      display: flex;
      align-items: center;
      justify-content: center;
      a {
        color: #bebebe;
        &:hover {
          color: #101820;
        }
      }

      @media (max-width: 568px) {
        flex: 1;
        margin-left: 0;
      }
    }
  }
}

.footer-bar__links__menu {
  padding: 1rem 0;
  width: 168px;

  .el-dropdown-menu__item {
    padding: 0;
    position: relative;
    font-size: 14px;
    color: $input-placeholder-color;

    a {
      width: 100%;
      margin-left: 1rem;
    }

    .footer-popover-reference {
      width: 100%;
      padding-left: 1rem;
      display: block;
      .el-popover__reference {
        width: calc(100% - 12px);
        display: flex;
      }
    }

    a {
      line-height: 2rem;
      letter-spacing: 0.28px;
      &:hover {
        background: none;
      }
    }

    &:hover {
      color: #101820;
      background: none;
    }
  }

  .popper__arrow {
    display: none !important;
  }

  &--contact {
    padding: 1rem !important;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0.28px;

    a {
      color: $input-placeholder-color;
    }
  }
}

.footer-popover {
  padding: 1rem;
  display: flex;
  margin: 0 1rem 1rem;
  flex-direction: column;
  background: white;
  // border: 1px solid $border-color;
  color: #000;
  font-size: 14px;
  line-height: 32px;
  letter-spacing: 0.28px;

  a {
    color: #000;
  }
}

.get-in-touch {
  padding: 0.5rem 1rem;
}

.dropdown {
  margin-right: 1rem;
}

.please {
  width: 110px;
  .dropdown-menu {
    border: 0;
    background: transparent;
    height: 0;
    margin: 0;
    padding: 0;
  }
  .dropdown-toggle {
    padding: 0;
    font-size: 14px;
    &::after {
      display: none !important;
    }
  }
}
</style>
